import { ChatbotStore, ChatbotAuthToken } from "./ChatbotStore";
import { SerializedData, Store, AnalyticsStore } from "bernie-core";
import { Logger, NOOP_LOGGER } from "bernie-logger";

export interface VacEvent {
  type: string;
}

export enum VacEventTypes {
  VAC_WIDGET_OPENED_EVENT = "VAC_WidgetOpened",
  VAC_WIDGET_CLOSED_EVENT = "VAC_WidgetClosed",
  VAC_WIDGET_READY_EVENT = "VAC_Ready",
  VAC_WIDGET_OPENED_RFRR_ID = "VA.FAB.Open",
  VAC_WIDGET_CLOSED_RFRR_ID = "VA.FAB.Closed",
  VAC_WIDGET_READY_RFRR_ID = "VA.FAB.Ready",
  VAC_WIDGET_OPENED_DESCRIPTION = "VAC Widget Opened",
  VAC_WIDGET_CLOSED_DESCRIPTION = "VAC Widget Closed",
  VAC_WIDGET_READY_DESCRIPTION = "VAC Widget Ready"
}

export class ClientChatbotStore extends Store implements ChatbotStore {
  public authToken: ChatbotAuthToken;
  public channelOriginId: string;
  public staticJSScript: string;
  public locale?: string;
  public chatbotExperimentOn?: boolean;
  public subscribedEvents = [
    VacEventTypes.VAC_WIDGET_OPENED_EVENT,
    VacEventTypes.VAC_WIDGET_CLOSED_EVENT,
    VacEventTypes.VAC_WIDGET_READY_EVENT
  ];

  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    this.authToken = data.authToken;
    this.channelOriginId = data.channelOriginId;
    this.authToken = data.authToken;
    this.staticJSScript = data.staticJSScript;
    this.locale = data.locale;
    this.chatbotExperimentOn = data.chatbotExperimentOn;
  }

  public eventHandler(analyticsStore: AnalyticsStore, event: VacEvent) {
    switch (event.type) {
      case VacEventTypes.VAC_WIDGET_OPENED_EVENT:
        analyticsStore.trackEvent(
          VacEventTypes.VAC_WIDGET_OPENED_RFRR_ID,
          VacEventTypes.VAC_WIDGET_OPENED_DESCRIPTION,
          analyticsStore.omnitureData
        );
        break;
      case VacEventTypes.VAC_WIDGET_CLOSED_EVENT:
        analyticsStore.trackEvent(
          VacEventTypes.VAC_WIDGET_CLOSED_RFRR_ID,
          VacEventTypes.VAC_WIDGET_CLOSED_DESCRIPTION,
          analyticsStore.omnitureData
        );
        break;
      case VacEventTypes.VAC_WIDGET_READY_EVENT:
        analyticsStore.trackEvent(
          VacEventTypes.VAC_WIDGET_READY_RFRR_ID,
          VacEventTypes.VAC_WIDGET_READY_DESCRIPTION,
          analyticsStore.omnitureData
        );
        break;
      default:
        break;
    }
  }
}
